module.exports = __webpack_public_path__ + "tables/media/Settings_outlined.430649b1.svg";